import directive from './directive'
import Contextmenu from './components/context-menu/Contextmenu.vue'
import ContextmenuItem from './components/context-menu/ContextmenuItem.vue'
import ContextmenuSubmenu from './components/context-menu/ContextmenuSubmenu.vue'
import ContextmenuGroup from './components/context-menu/ContextmenuGroup.vue'

import TreeRoot from './components/TreeRoot.vue'

const install = Vue => {
  Vue.directive('contextmenu', directive)
  Vue.component(Contextmenu.name, Contextmenu)
  Vue.component(ContextmenuItem.name, ContextmenuItem)
  Vue.component(ContextmenuSubmenu.name, ContextmenuSubmenu)
  Vue.component(ContextmenuGroup.name, ContextmenuGroup)

  Vue.component(TreeRoot.name, TreeRoot)
}

TreeRoot.install = install

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TreeRoot)
}

export {
  directive,
  Contextmenu,
  ContextmenuItem,
  ContextmenuSubmenu,
  ContextmenuGroup,
}

export default TreeRoot
